import { render, staticRenderFns } from "./BarangayVotersList.vue?vue&type=template&id=1cccdccf"
import script from "./BarangayVotersList.vue?vue&type=script&lang=js"
export * from "./BarangayVotersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports